import { render, staticRenderFns } from "./NewUserUpdate.vue?vue&type=template&id=84bb04ec&"
import script from "./NewUserUpdate.vue?vue&type=script&lang=js&"
export * from "./NewUserUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports